import axios from "../../network/axios";

const getCartById = async (
  userId: string,
  vendorId: string,
  cartId: string
) => {
  try {
    const url = `${process.env.REACT_APP_CART_API_URL}/carts/${cartId}?userId=${userId}&vendorId=${vendorId}`;
    const { data } = await axios.get(url);
    return data;
  } catch (e) {
    throw new Error("Could not get cart");
  }
};

export default getCartById;
